module.exports = __webpack_public_path__ + "img/five guys.2cf33622.jpg";